import React from "react";
import { ArrowLeft, UserRoundPlus } from "lucide-react";
import { DateRange } from "react-date-range";
import { parseISO, format } from "date-fns";
import MemberList from "../MemberList";

const formatTripDateRange = (startDate, endDate) => {
  const start = parseISO(startDate);
  const end = parseISO(endDate);
  return `${start.getDate()}/${start.getMonth() + 1} - ${end.getDate()}/${end.getMonth() + 1}`;
};

const TripHeader = ({
  trip,
  tripId,
  navigate,
  editingField,
  editingValue,
  showDatePicker,
  dateRange,
  memberRefreshKey,
  setEditingField,
  setEditingValue,
  setShowDatePicker,
  setShowMemberModal,
  handleInputChange,
  handleInputBlur,
  handleInputKeyDown,
  saveField,
  setTrip,
}) => {
  return (
    <div className="sticky top-0 z-10 bg-white border-b shadow px-4 sm:px-6 py-3 sm:py-4 rounded-lg mb-6">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 sm:gap-4">
        <button
          onClick={() => navigate("/dashboard")}
          className="text-gray-600 hover:text-primary flex items-center gap-1"
        >
          <ArrowLeft size={20} />
          <span className="hidden sm:inline">Back</span>
        </button>
      </div>

      {/* Trip Name */}
      <div className="mt-2">
        {editingField === "name" ? (
          <input
            type="text"
            value={editingValue}
            onChange={handleInputChange}
            onBlur={handleInputBlur}
            onKeyDown={handleInputKeyDown}
            autoFocus
            className="text-xl sm:text-2xl font-bold text-primary border-b border-primary outline-none w-full"
          />
        ) : (
          <h2
            className="text-2xl font-bold text-primary cursor-pointer hover:underline truncate max-w-full"
			onClick={() => {
				setEditingField("name");
				setEditingValue(trip.name);  // 🛠 初始化為現有名稱
			}}
          >
            {trip.name}
          </h2>
        )}
      </div>

      {/* 日期與成員列 */}
      <div className="mt-2 flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2">
        <div className="text-sm text-gray-600">
          {editingField === "start_date" || editingField === "end_date" ? (
            <div className="flex gap-2 items-center">
              <input
                type="date"
                value={editingField === "start_date" ? editingValue : trip.start_date}
                onChange={handleInputChange}
                onBlur={handleInputBlur}
                onKeyDown={handleInputKeyDown}
                autoFocus
                className="border px-2 py-1 rounded"
              />
            </div>
          ) : (
            <span
              className="cursor-pointer hover:underline"
              onClick={() => setShowDatePicker(!showDatePicker)}
            >
              {formatTripDateRange(trip.start_date, trip.end_date)}
            </span>
          )}
        </div>
		{/* 成員列表與新增按鈕：換行處理 */}
        <div className="flex flex-wrap items-center gap-2 mt-2 sm:mt-0">
          <MemberList tripId={tripId} refreshKey={memberRefreshKey} compact />
          <button
            onClick={() => setShowMemberModal(true)}
            className="p-2 rounded-full bg-gray-100 hover:bg-gray-200 text-primary"
            title="Add Member"
          >
            <UserRoundPlus size={18} />
          </button>
        </div>
      </div>

		{showDatePicker && (
		  <div className="relative mt-2">
			<div className="fixed top-20 left-1/2 transform -translate-x-1/2 z-[9999] bg-white shadow-xl rounded p-4">
			  <DateRange
				ranges={dateRange}
				onChange={(ranges) => {
				  setTrip((prev) => ({
					...prev,
					start_date: format(ranges.selection.startDate, "yyyy-MM-dd"),
					end_date: format(ranges.selection.endDate, "yyyy-MM-dd"),
				  }));
				}}
				moveRangeOnFirstSelection={false}
			  />
			  <div className="mt-2 flex gap-2 justify-end">
				<button
				  className="bg-primary text-white px-3 py-1 rounded hover:bg-orange-600"
				  onClick={async () => {
					const token = localStorage.getItem("token");
					const res = await fetch(`${process.env.REACT_APP_API_URL}/trips/update_trip/${tripId}`, {
					  method: "PUT",
					  headers: {
						"Content-Type": "application/json",
						Authorization: `Bearer ${token}`,
					  },
					  body: JSON.stringify({
						name: trip.name,
						start_date: format(dateRange[0].startDate, "yyyy-MM-dd"),
						end_date: format(dateRange[0].endDate, "yyyy-MM-dd"),
					  }),
					});
					if (res.ok) {
					  setShowDatePicker(false);
					} else {
					  alert("Failed to save dates");
					}
				  }}
				>
				  Save Dates
				</button>

				<button
				  className="bg-gray-300 text-gray-800 px-3 py-1 rounded hover:bg-gray-400"
				  onClick={() => setShowDatePicker(false)}
				>
				  Cancel
				</button>
			  </div>
			</div>
		  </div>
		)}
    </div>
  );
};

export default TripHeader;
